var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.164,
    height: 6.167,
    viewBox: "0 0 9.164 6.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,45.689a.256.256,0,0,1-.007.076l-.565,2.261a.257.257,0,0,1-.248.195l-3.392.017H1.2a.257.257,0,0,1-.249-.195l-.565-2.27a.257.257,0,0,1-.007-.078.54.54,0,1,1,.5-.1l.708.713a.961.961,0,0,0,1.448-.1L4.2,44.671a.54.54,0,1,1,.771-.009h0l1.155,1.545a.964.964,0,0,0,.769.385.953.953,0,0,0,.678-.281l.712-.712a.54.54,0,1,1,.517.088Zm-.627,3.354a.257.257,0,0,0-.257-.257H1.273a.257.257,0,0,0-.257.257v.617a.257.257,0,0,0,.257.257H7.919a.257.257,0,0,0,.257-.257Z",
    transform: "translate(0 -43.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.2742ad9c.svg";
export { ForwardRef as ReactComponent };